export { SimpleTextWidgetRenderer } from './SimpleTextWidgetRenderer'
export type { SimpleTextWidgetRendererProps } from './SimpleTextWidgetRenderer'
